import { Component } from '@angular/core';

@Component({
  selector: 'maintenance-tooltip',
  templateUrl: './maintenance-tooltip.component.html',
  styleUrls: ['./maintenance-tooltip.component.scss']
})
export class MaintenanceTooltipComponent {

}
